import { Checkbox, FormControl, InputLabel, ListItemText, MenuItem, Select } from '@mui/material';
import React from 'react';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  icon: {
    '&:hover': {
      fill: theme.palette.components.icons.secondary.backgroundColor,
    },
  },
}));

export const RadioDropDown = ({ title, options, value: selected, onChange, overrideClasses, disabled }) => {
  const { classes } = useStyles();

  return (
    <FormControl variant="filled" classes={{ root: overrideClasses.container }}>
      {title ? <InputLabel shrink={!!selected}>{title}</InputLabel> : null}
      <Select
        value={selected}
        onChange={onChange}
        IconComponent={ExpandMoreOutlinedIcon}
        renderValue={selection => options.find(item => item.value === selection).name}
        MenuProps={{
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
          },
        }}
        disabled={disabled}
      >
        {options.map(({ name, value }) => (
          <MenuItem key={name} value={value}>
            <Checkbox
              icon={<RadioButtonUncheckedIcon />}
              checkedIcon={<RadioButtonCheckedIcon classes={{ root: classes.icon }} />}
              checked={selected === value}
            />
            <ListItemText primary={name} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
